"use client";

import Link from "next/link";
import { ArrowRight, GraduationCap, Users, Star, Zap } from "lucide-react";

/**
 * GuitarChoNguoiMoiCTA
 * Drop anywhere on the homepage. Links to /guitar-cho-nguoi-moi.
 */
export function GuitarChoNguoiMoiCTA() {
  return (
    <section
      className="w-full px-4 sm:px-6 lg:px-8 py-4"
      aria-label="Guitar cho người mới bắt đầu"
      style={{ fontFamily: "var(--font-roboto)" }}
    >
      <Link
        href="/guitar-cho-nguoi-moi"
        className="group block max-w-7xl mx-auto rounded-3xl border overflow-hidden transition-all duration-300"
        style={{
          backgroundColor: "var(--card)",
          borderColor: "rgba(200,169,110,0.28)",
          textDecoration: "none",
        }}
        onMouseEnter={(e) => {
          const el = e.currentTarget as HTMLElement;
          el.style.borderColor = "rgba(200,169,110,0.55)";
          el.style.boxShadow = "0 20px 56px rgba(0,0,0,0.22), 0 0 0 1px rgba(200,169,110,0.1)";
        }}
        onMouseLeave={(e) => {
          const el = e.currentTarget as HTMLElement;
          el.style.borderColor = "rgba(200,169,110,0.28)";
          el.style.boxShadow = "none";
        }}
      >
        {/* Gold top bar */}
        <div
          className="h-1"
          style={{
            background: "linear-gradient(to right, var(--brand-primary), rgba(200,169,110,0.35))",
          }}
        />

        <div className="p-6 sm:p-8 lg:p-10 flex flex-col lg:flex-row items-start lg:items-center gap-8">
          {/* Left */}
          <div className="flex items-start gap-5 flex-1 min-w-0">
            <div
              className="shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-2xl flex items-center justify-center border transition-all duration-300 group-hover:scale-105"
              style={{
                backgroundColor: "rgba(200,169,110,0.1)",
                borderColor: "rgba(200,169,110,0.3)",
              }}
            >
              <GraduationCap className="w-7 h-7 sm:w-8 sm:h-8" style={{ color: "var(--brand-primary)" }} />
            </div>

            <div className="flex-1 min-w-0">
              <span
                className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold border mb-3"
                style={{
                  backgroundColor: "rgba(200,169,110,0.08)",
                  borderColor: "rgba(200,169,110,0.3)",
                  color: "var(--brand-primary)",
                  fontFamily: "var(--font-montserrat)",
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                }}
              >
                <Users className="w-3 h-3" />
                500+ học viên · Cộng đồng Sài Gòn
              </span>

              <h2
                className="text-xl sm:text-2xl font-black leading-tight mb-2"
                style={{ fontFamily: "var(--font-montserrat)", color: "var(--foreground)" }}
              >
                Guitar Cho{" "}
                <span style={{ color: "var(--brand-primary)" }}>Người Mới</span>{" "}
                Bắt Đầu
              </h2>

              <p className="text-sm sm:text-base mb-4" style={{ color: "var(--muted-foreground)" }}>
                Acoustic hay classic? Tầm giá bao nhiêu? Tránh những lỗi gì? Hướng dẫn{" "}
                <strong style={{ color: "var(--foreground)" }}>thật thà từ người đã đi qua</strong>{" "}
                — không bán hàng, chỉ chia sẻ thực tế.
              </p>

              {/* Stars */}
              <div className="flex items-center gap-1.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5 fill-current" style={{ color: "var(--brand-primary)" }} />
                ))}
                <span className="text-xs ml-1" style={{ color: "var(--muted-foreground)" }}>
                  Học thử miễn phí · Không cam kết trước
                </span>
              </div>
            </div>
          </div>

          {/* Right: CTA */}
          <div className="flex-shrink-0 w-full lg:w-auto">
            <div
              className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded-xl font-black text-sm transition-all duration-200 group-hover:opacity-90 active:scale-[0.97] w-full lg:w-auto justify-center"
              style={{
                fontFamily: "var(--font-montserrat)",
                backgroundColor: "var(--brand-primary)",
                color: "var(--brand-primary-foreground)",
                boxShadow: "0 4px 20px rgba(200,169,110,0.28)",
              }}
            >
              <Zap className="w-4 h-4" />
              Xem hướng dẫn
              <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
            </div>
            <p className="text-xs text-center mt-2" style={{ color: "var(--muted-foreground)" }}>
              Acoustic · Classic · Tầm giá · Lỗi cần tránh
            </p>
          </div>
        </div>
      </Link>
    </section>
  );
}